// extracted by mini-css-extract-plugin
export default {"container":"Blog_container__qlDdO","flex":"Blog_flex__Jav0o","align-right":"Blog_align-right__bMIR5","btn":"Blog_btn__g0Tgb"};